<rt-dialog-body variant="white">
  @if (applyResult(); as result) {
    @if (result.success) {
      <div class="icon-container success">
        <div class="icon-inner">
          <rt-icon name="check" size="large-x" colorToken="colorIconOnsuccessDefault" />
        </div>
      </div>
      <div class="text-container">
        <rt-heading variant="heading" class="heading"
          >{{ 'tlc.positions.import_skills_flow.result_dialog.success.heading' | translate }}
        </rt-heading>
        <span class="description">{{
          'tlc.positions.import_skills_flow.result_dialog.success.description'
            | translate: { skillsCount: skillsCount(), positionsCount: positionsCount() }
        }}</span>
      </div>
      <div class="buttons-container">
        <a
          rt-button
          variant="tertiary"
          href="https://feedback.tellent.com/tellenthr-manage?selectedCategory=positions-skills"
          target="_blank"
        >
          <rt-icon name="edit" />
          <span>{{
            'tlc.positions.import_skills_flow.result_dialog.success.give_feedback' | translate
          }}</span>
        </a>
        <rt-button variant="primary" (click)="close()"
          >{{
            'tlc.positions.import_skills_flow.result_dialog.success.finish_and_close' | translate
          }}
        </rt-button>
      </div>
    } @else {
      <div class="icon-container failed">
        <div class="icon-inner">
          <rt-icon name="close" size="large-x" colorToken="colorIconOncriticalDefault" />
        </div>
      </div>
      <div class="text-container">
        <rt-heading variant="heading" class="heading"
          >{{ 'tlc.positions.import_skills_flow.result_dialog.failed.heading' | translate }}
        </rt-heading>
        <span class="description">{{
          'tlc.positions.import_skills_flow.result_dialog.failed.description' | translate
        }}</span>
      </div>

      <div class="buttons-container">
        <rt-button variant="tertiary" (click)="reviewAndTryAgain()">
          <rt-icon name="arrow-back" />
          <span>{{
            'tlc.positions.import_skills_flow.result_dialog.failed.review_and_try_again' | translate
          }}</span>
        </rt-button>
        <rt-button variant="tertiary" (click)="close()">
          <rt-icon name="close" />
          <span>{{
            'tlc.positions.import_skills_flow.result_dialog.failed.discard_and_close' | translate
          }}</span>
        </rt-button>
      </div>
    }
  }
</rt-dialog-body>
